export enum DateAndTimeDataHooks {
  SLOT_DATE_AND_TIME = 'booking-details-slot-date-and-time',
}
